export default __webpack_public_path__ + "static/media/CellFree_FR.6066c77f.pdf";